module.exports = __webpack_public_path__ + "img/img1.88c66a60.jpg";